<navaar-container-scroll
    class="list-categories"
    [showHeader]="true"
    [title]="'جست و جو'"
    [show]="true"
    [isPlayAnimation]="false"
    [showIcon]="true"
    [isFixedContainer]="true"
>
    <section class="book-search-form">
        <div
            class="container"
            style="padding-top: 15px !important;"
        >
            <input
                style="cursor: pointer;padding-bottom: 12px;"
                (keyup)="onSearch($event)"
                [value]="wordSearch"
                (input)="wordSearch = $any($event.target).value"
                type="text"
                class="search-field"
                placeholder="عنوان، نویسنده، مترجم، ناشر و ..."
                autocomplete="off"
                handleEventCodeProcess
                (enter-press)="onSearch($event)"
                #search_input
            >
         <span (click)="reset()" *ngIf="wordSearch?.length > 0" id="close-icon-wrapper" hidden> <navaar-close-new-icon></navaar-close-new-icon></span>
        </div>
    </section>
    <div
        class="book-search-result"
        style="min-height: 80vh;"
    >
        <ul
            id="history-container"
            *ngIf="!items.length && itemsSearched.size > 0"
        >
            <caption>جستجوهای گذشته</caption>
            <ng-template
                ngFor
                [ngForOf]="itemsSearched | reverseArray"
                let-item
            >
                <li (click)="searchSelected(item)">
                    <span [textContent]="item"></span>
                </li>
            </ng-template>
        </ul>
        <navaar-list-items
            class="catalog-list"
            *ngIf="items.length > 0"
            (go-to)="goToNextPage($event)"
            [disable-when-fetch-data]="isLoading"
            [isEnd]="isEnd"
            [items]="items"
            [type]="'none'"
            [more-icon]="false"
        ></navaar-list-items>
        <section
            *ngIf="isEmptyResultSearch"
            class="book-search-section book-search-result-fail"
        >
            <div class="empty-book">
                <div class="fail-ico">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="1467.5 2684 71 39.495"
                        id="bad-serch"
                        class="icon-svg-bad-serch"
                    >
                        <g
                            data-name="Group 1109"
                            transform="translate(1429.5 2601)"
                        >
                            <g
                                data-name="Group 1107"
                                transform="translate(-5)"
                            >
                                <g
                                    data-name="Ellipse 104"
                                    transform="translate(58 83)"
                                >
                                    <circle
                                        cx="5"
                                        cy="5"
                                        r="5"
                                    ></circle>
                                    <circle
                                        cx="5"
                                        cy="5"
                                        r="4.5"
                                    ></circle>
                                </g>
                                <g
                                    data-name="Ellipse 105"
                                    transform="translate(88 83)"
                                >
                                    <circle
                                        cx="5"
                                        cy="5"
                                        r="5"
                                    ></circle>
                                    <circle
                                        cx="5"
                                        cy="5"
                                        r="4.5"
                                    ></circle>
                                </g>
                            </g>
                            <path
                                data-name="Path 519"
                                d="M108.5 121.628C99.7 115.031 87.61 111 73.683 111S47.3 115.031 38.5 121.995"
                            ></path>
                        </g>
                    </svg>
                </div>
                <div class="fail-result-txt">هیچ کتابی یافت نشد!</div>
                <navaar-carousel
                    [title]="'کتاب‌های پیشنهادی نوار'"
                    [typeOfCarousel]="carousel.image_Only"
                    [items]="itemsForEmptySearch"
                    *ngIf="itemsForEmptySearch"
                ></navaar-carousel>
            </div>
        </section>
    </div>
</navaar-container-scroll>
